<template>
	<div>
		<ProgressBar :isLoading="loadingData"/>
		<alert-basic
			:message="alert.message"
			:type="alert.type"
			:show="alert.show"
			@updateShow="alert.show = $event"
		></alert-basic>
		<v-container>
			<BillingEngineFilters
				v-show="showBillingEngineFilters"
				@submit="getBillingEngineData"
				@submitExcelExport="getBillingEngineExcel"
				:appNameShort="appNameShort"
				:disableButtons="loadingData"
				:showFilters="showFilters"
				@filtersShallAppear="showFilters = true; showDataTable = false"
			/>
		</v-container>
		<BillingEngineTable
			v-show="showDataTable"
			:billingEngineData="billingEngineData"
		/>
		<BillingEnginePagination
			v-show="showDataTable"
			:itemsCount="itemsCount"
			@paginationCurrentPageChanged="paginationEventHandler"
		/>
	</div>
</template>

<script>
import axios from 'axios'
import ProgressBar from '../vueBasics/Progressbar.vue'
import BillingEngineFilters from './filters/BillingEngineFilters.vue'
import BillingEngineTable from './BillingEngineTable.vue'
import BillingEnginePagination from './BillingEnginePagination.vue'
import AlertBasic from '../vueBasics/AlertBasic.vue'

export default {
	name: 'billingEngine',
	props: ['approvedMandators'],
	components: {
		ProgressBar,
		BillingEngineFilters,
		BillingEngineTable,
		BillingEnginePagination,
		AlertBasic,
	},
	data() {
		return {
			appNameShort: 'be',
			loadingData: false,
			showDataTable: false,
			showFilters: true,
			showBillingEngineFilters: true,
			billingEngineData: [],
			alert: {
				show: false,
				message: '',
				type: '',
			},
			itemsCount: 0,
			componentKey: 0,
			pagination: Number,
			filterOptionsSelected: Object,
		}
	},
	watch: {
		pagination: {
			handler(value) {
				this.getBillingEngineData(this.filterOptionsSelected, value)
			},
		},
	},
	computed: {
	},
	methods: {
		async getBillingEngineData(filterOptions, pagination = 1) {
			this.filterOptionsSelected = filterOptions
			try {
				this.loadingData = true
				const billingEngineData = await axios.post(
					`${config.baseAPIurl}/billing-engine/data`,
					{
						mandator: filterOptions.mandator,
						fromDate: filterOptions.fromDate,
						tillDate: filterOptions.tillDate,
						serviceproviders: filterOptions.serviceproviders,
						products: filterOptions.products,
						salesChannels: filterOptions.salesChannels,
						bookings: filterOptions.bookings,
						orderIds: filterOptions.orderIds,
						paymentTransactionIds: filterOptions.paymentTransactionIds,
						couponCodes: filterOptions.couponCodes,
						productSkuFirstParts: filterOptions.productSkuFirstParts,
						regions: filterOptions.regions,
						paymentProviders: filterOptions.paymentProviders,
						paymentMethods: filterOptions.paymentMethods,
						pagination: {
							page: pagination,
							perPage: 100,
						},
					},
				)
				if (billingEngineData.data.billingEngineData.length === 1 && billingEngineData.data.billingEngineData[0] === 'There are no billing engine data to display to this filters') {
					this.alert.show = true
					this.alert.message = billingEngineData.data.billingEngineData[0]
					this.alert.type = 'info'
					this.showDataTable = false
					this.loadingData = false
					this.scrollToTop()
					return
				}
				this.billingEngineData = billingEngineData.data.billingEngineData
				this.itemsCount = new Number(billingEngineData.data.dataLength)
				this.showDataTable = true
				this.loadingData = false
				this.showFilters = false
			} catch (e) {
				this.loadingData = false
				this.alert.show = true
				this.alert.message = 'Due to an error the the data could not be loaded.'
				this.alert.type = 'error'
				this.scrollToTop()
			}
		},
		scrollToTop() {
			window.scrollTo(0, 0)
		},
		paginationEventHandler(value) {
			this.pagination = value
		},
		async getBillingEngineExcel(filterOptions) {
			this.filterOptionsSelected = filterOptions
			const filters = {
				mandator: filterOptions.mandator,
				fromDate: filterOptions.fromDate,
				tillDate: filterOptions.tillDate,
				serviceproviders: filterOptions.serviceproviders,
				products: filterOptions.products,
				salesChannels: filterOptions.salesChannels,
				bookings: filterOptions.bookings,
				orderIds: filterOptions.orderIds,
				paymentTransactionIds: filterOptions.paymentTransactionIds,
				couponCodes: filterOptions.couponCodes,
				productSkuFirstParts: filterOptions.productSkuFirstParts,
				regions: filterOptions.regions,
				paymentProviders: filterOptions.paymentProviders,
				paymentMethods: filterOptions.paymentMethods,
				pagination: {
					page: 1,
					perPage: 100,
				},
			}

			this.loadingData = true
			try {
				const response = await axios({
					method: 'post',
					url: `${config.baseAPIurl}/billing-engine/excel`,
					data: filters,
					responseType: 'blob',
				})
				let filenameExtension
				if (filters.dateFrom === filters.dateTill) {
					filenameExtension = filters.dateFrom
				} else {
					filenameExtension = `${filters.dateFrom}-${filters.dateTill}`
				}
				saveAs(new Blob([response.data]), `billing_engine_report_${filenameExtension}.xlsx`)
				this.showDataTable = true
				this.loadingData = false
				this.showFilters = false
			} catch (err) {
				this.loadingData = false
				this.alert.show = true
				this.alert.message = 'Due to an error the the data could not be loaded.'
				this.alert.type = 'error'
				this.scrollToTop()
			}
		},
	},
	mounted() {
	},
}
</script>

<style scoped>

</style>
